import ku from './ku';
import en from './en';
import ar from './ar';

export default {
    ku, en, ar
}